import { Profession } from '@common/enums';

export const processActorProfessions = [
    Profession.bariNurse,
    Profession.dietitian,
    Profession.lifestyleCoach,
    Profession.outpatientAssistant,
    Profession.osasNurse,
    Profession.medicalSpecialist,
    Profession.basicPsychologist,
] as const;

export type ProcessActorProfession = (typeof processActorProfessions)[number];
